var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "elements"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M13.667 0.75V2.5M3.66699 0.75V2.5",
    stroke: "#3D3D3D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M8.6626 10.375H8.67008M8.6626 13.875H8.67008M11.9922 10.375H11.9997M5.33301 10.375H5.34048M5.33301 13.875H5.34048",
    stroke: "#3D3D3D",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 4046",
    d: "M1.58301 6H15.7497",
    stroke: "#3D3D3D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M0.75 9.71284C0.75 5.90019 0.75 3.99387 1.79343 2.80944C2.83686 1.625 4.51624 1.625 7.875 1.625H9.45833C12.8171 1.625 14.4965 1.625 15.5399 2.80944C16.5833 3.99387 16.5833 5.90019 16.5833 9.71284V10.1622C16.5833 13.9748 16.5833 15.8811 15.5399 17.0656C14.4965 18.25 12.8171 18.25 9.45833 18.25H7.875C4.51624 18.25 2.83686 18.25 1.79343 17.0656C0.75 15.8811 0.75 13.9748 0.75 10.1622V9.71284Z",
    stroke: "#3D3D3D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 4049",
    d: "M1.16699 6H16.167",
    stroke: "#3D3D3D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.d9cdd8d5b6e0ed1b08c72d038bf5d769.svg";
export { ForwardRef as ReactComponent };